import React from 'react';
import { Col, Card, Row, Button, Image } from "react-bootstrap";
import PlayBtn from '../../../assets/icons/Play circle.svg';
import Coffee from '../../../assets/icons/Coffee.svg';
import LeaveBtn from '../../../assets/icons/Pause.svg';

const TodayShift = ({ clockState, entryTime, exitTime, pauseDuration, formatTime, handleShowModal }) => (
    <Col className='col-4'>
        <Card className='rounded-4 shadow' style={{ backgroundColor: "#0E46A3", height: "100%" }}>
            <div className='m-3'>
                <Row className='m-1'>
                    <Col>
                        <b style={{ color: "#ffffff", fontSize: "2.5vmin" }}>Turno de Hoje: 8:00 - 17:00</b>
                    </Col>
                </Row>
                <Row className='d-flex justify-content-center mt-1'>
                    <Col className='col-12 d-flex'>
                        {clockState === 'not_started' ? (
                            <Button
                                className='w-100 d-flex justify-content-center align-items-center gap-1 rounded-4 border-0 mt-3'
                                style={{ backgroundColor: "#1E0342", color: "white" }}
                                onClick={() => handleShowModal('start')}
                            >
                                <Image src={PlayBtn} style={{ scale: "2.5vmin" }} />
                                <b style={{ fontSize: "2.5vmin" }}>Registar Entrada</b>
                            </Button>
                        ) : (
                            <div className='d-flex w-100 gap-1 mt-4'>
                                <Button
                                    className={clockState === 'paused' ? 'w-100 rounded-3' : 'w-50 rounded-3'}
                                    style={{ backgroundColor: "#1E0342", color: "white" }}
                                    onClick={() => handleShowModal(clockState === 'paused' ? 'return' : 'pause')}
                                >
                                    <b className='fs-6 d-flex justify-content-center align-items-center gap-1' style={{ fontSize: "2.5vmin" }}>
                                        {clockState === 'paused' ? <Image src={PlayBtn} /> : <Image src={Coffee} />}
                                        {clockState === 'paused' ? <span style={{ fontSize: "2.5vmin" }}>Registar Retorno</span> : <span style={{ fontSize: "2.5vmin" }}>Fazer Pausa</span>}
                                    </b>
                                </Button>
                                {clockState !== 'paused' && (
                                    <Button
                                        className='w-50 d-flex justify-content-center align-items-center gap-1 rounded-3'
                                        style={{ backgroundColor: "#1E0342", color: "white" }}
                                        onClick={() => handleShowModal('leave')}
                                    >
                                        <Image src={LeaveBtn} />
                                        <b style={{ fontSize: "2.5vmin" }}>Registar Saída</b>
                                    </Button>
                                )}
                            </div>
                        )}
                    </Col>
                </Row>
                <Row className='mt-3 text-center' style={{ color: "#ffffff" }}>
                    <Col style={{ borderRight: "1px solid #ffffff" }}>
                        <b style={{ display: "block", fontSize: "2.5vmin" }}>Entrada</b>
                        <span style={{ display: "block", fontSize: "2.5vmin" }}>
                            {formatTime(entryTime)}
                        </span>
                    </Col>
                    <Col style={{ borderRight: "1px solid #ffffff" }}>
                        <b style={{ display: "block", fontSize: "2.5vmin" }}>Pausas</b>
                        <span style={{ display: "block", fontSize: "2.5vmin" }}>
                            {pauseDuration || '-'}
                        </span>
                    </Col>
                    <Col>
                        <b style={{ display: "block", fontSize: "2.5vmin" }}>Saída</b>
                        <span style={{ display: "block",fontSize: "2.5vmin" }}>
                            {formatTime(exitTime)}
                        </span>
                    </Col>
                </Row>
            </div>
        </Card>
    </Col>
);

export default TodayShift;
